export const BASE_URL = 'http://localhost:8000/api/v1';
